module.exports = __webpack_public_path__ + "static/media/stories_homepage.6c532e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stories_homepage.png
// module id = 659
// module chunks = 0